// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".ele-form-section .el-form{border:1px solid #ebeef5;padding:0 20px}.ele-form-section-header{padding:18px 0;border-bottom:1px solid #ebeef5;-webkit-box-sizing:border-box;box-sizing:border-box;margin-bottom:15px}", ""]);
// Exports
module.exports = exports;
